import styled from 'styled-components';
import { Image } from 'shared/components/Image';

import { IProductSearch } from 'shared/types/ProductSearch';
import { LocalizedCurrency } from 'shared/components/LocalizedCurrency';
import { variableFontRegular } from 'styles/theme/text';
import { useStoreSelector } from 'store/hooks/storeHooks';

interface IStandardVariantGridItem {
  className?: string;
  productSearch: IProductSearch;
  onClick: (variant: IProductSearch) => void;
}

export const StandardVariantGridItem = ({
  className,
  productSearch,
  onClick,
}: IStandardVariantGridItem) => {
  const { name } = useStoreSelector((state) => state.pdp.productTemplate);
  const { localizedPriceCents, thumbOuterPictureUrl, outerPictureUrl } = productSearch;

  return (
    <StandardVariantGridItem.Link
      className={className}
      data-qa="variant_item_link"
      onClick={() => onClick(productSearch)}
    >
      <Image
        alt={name}
        data-qa="variant_item_image"
        disableLazyLoad
        sizes="20vw"
        src={thumbOuterPictureUrl || outerPictureUrl}
      />
      <StandardVariantGridItem.Price
        data-qa="variant_item_price"
        price={localizedPriceCents?.amount}
      />
    </StandardVariantGridItem.Link>
  );
};

StandardVariantGridItem.Link = styled.div`
  cursor: pointer;

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    width: 60px;

    :hover {
      text-decoration: underline;
    }
  }
`;

StandardVariantGridItem.Price = styled(LocalizedCurrency)`
  display: block;

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    color: ${({ theme }) => theme.colors.white};
    margin-top: 16px;

    ${variableFontRegular({ height: '16px', size: '16px' })};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    margin-top: 6px;

    ${variableFontRegular({ height: '9px', size: '9.5px' })};
  }
`;
